// src/components/layout/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { getTranslations } from '../../languages';

function Footer() {
  const { language } = useLanguage();
  const translations = getTranslations(language);
  
  // Get the link texts from translations
  const linkTexts = translations.footer.links;
  
  // Handler für den Cookie-Settings-Link um sicherzustellen, 
  // dass die Seite neu geladen wird, wenn man sich bereits auf der Privacy-Policy-Seite befindet
  const handleCookieSettingsClick = (e) => {
    // Prüfen, ob wir bereits auf der Privacy-Policy-Seite sind
    const currentPath = window.location.pathname;
    const targetPath = `/${language}/privacy-policy`;
    
    if (currentPath === targetPath) {
      e.preventDefault(); // Standard-Navigation verhindern
      
      // Manuell die URL ändern und den Scroll einleiten
      document.getElementById('cookie-settings-section')?.scrollIntoView({ behavior: 'smooth' });
      
      // URL aktualisieren, ohne die Seite neu zu laden
      window.history.pushState(null, '', `${targetPath}#cookie-settings-section`);
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-links" style={{ marginBottom: '15px' }}>
          <Link 
            to={`/${language}/privacy-policy`} 
            style={{ 
              color: '#858585', 
              textDecoration: 'none',
              marginRight: '20px',
              fontSize: '0.9rem'
            }}
          >
            {linkTexts.privacyPolicy}
          </Link>
          <Link 
            to={`/${language}/privacy-policy#cookie-settings-section`} 
            onClick={handleCookieSettingsClick}
            style={{ 
              color: '#858585', 
              textDecoration: 'none',
              marginRight: '20px',
              fontSize: '0.9rem'
            }}
          >
            {linkTexts.cookieSettings}
          </Link>
          <Link 
            to={`/${language}/impressum`} 
            style={{ 
              color: '#858585', 
              textDecoration: 'none',
              fontSize: '0.9rem'
            }}
          >
            {linkTexts.impressum}
          </Link>
        </div>
        <p>&copy; {new Date().getFullYear()} Lucent Web Design. {translations.footer.copyright}</p>
        <div className="social">
          {/* Social Media Icons */}
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label={translations.footer.socialLinks.facebook}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
            </svg>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label={translations.footer.socialLinks.twitter}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
            </svg>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label={translations.footer.socialLinks.instagram}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label={translations.footer.socialLinks.linkedin}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
              <rect x="2" y="9" width="4" height="12"></rect>
              <circle cx="4" cy="4" r="2"></circle>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;